import React from "react";
import ConfirmDocuments from "../../views/ConfirmDocuments/ConfirmDocuments";
import UploadService from "../../services/UploadService";

const ConfirmDocumentsLP = () => {
    return <ConfirmDocuments uploadAction={UploadService.uploadStatementLP}/>
}
export default ConfirmDocumentsLP;
